module.exports = __webpack_public_path__ + "img/KL接线箱.9e2ac74a.jpg";